import './monitoring/sentry'
import { render } from 'preact'
import { App } from './app'
import './index.css'

// Setup Temporal polyfill globally for Schedule-X calendar
import { Temporal as TemporalPolyfill } from 'temporal-polyfill'

declare global {
  // eslint-disable-next-line no-var
  var Temporal: typeof TemporalPolyfill
}

if (typeof globalThis.Temporal === 'undefined') {
  globalThis.Temporal = TemporalPolyfill
}

render(<App />, document.getElementById('app')!)

// Prefetch vendor chunks during idle time to improve navigation performance
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    const chunksToPreload = [
      'vendor_nivo',      // Dashboard charts - typically accessed first
      'vendor_schedulex', // Calendar - accessed less frequently
    ]
    
    // Get all script tags to find the actual chunk filenames
    const scripts = Array.from(document.getElementsByTagName('script'))
    scripts.forEach(script => {
      const src = script.src
      chunksToPreload.forEach(chunkName => {
        if (src.includes(chunkName) && src.includes('.js')) {
          const link = document.createElement('link')
          link.rel = 'prefetch'
          link.as = 'script'
          link.href = src
          document.head.appendChild(link)
        }
      })
    })
  })
} else {
  // Fallback for browsers without requestIdleCallback
  setTimeout(() => {
    const chunksToPreload = [
      'vendor_nivo',      // Dashboard charts - typically accessed first
      'vendor_schedulex', // Calendar - accessed less frequently
    ]
    
    const scripts = Array.from(document.getElementsByTagName('script'))
    scripts.forEach(script => {
      const src = script.src
      chunksToPreload.forEach(chunkName => {
        if (src.includes(chunkName) && src.includes('.js')) {
          const link = document.createElement('link')
          link.rel = 'prefetch'
          link.as = 'script'
          link.href = src
          document.head.appendChild(link)
        }
      })
    })
  }, 3000)
}
